module.exports = __webpack_public_path__ + "static/competicao-5-0eda99db1a420fa9c6fbb8dc8b0c6867.jpeg";